// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeInboxMarkAllReadBody = {
  category?: "invite" | "pools" | "games" | "chat" | null;
};

export type typeInboxMarkAllReadOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { markedCount: number; unreadCount: number };
};

export type typeInboxMarkAllReadOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeInboxMarkAllReadOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeInboxMarkAllReadOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaInboxMarkAllReadBody = {
  type: "object",
  properties: {
    category: {
      oneOf: [
        { type: "string", enum: ["invite", "pools", "games", "chat"] },
        { enum: [null] },
      ],
    },
  },
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createInboxMarkAllRead(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaInboxMarkAllReadBody);
  }

  return async function postInboxMarkAllRead(
    payload: typeInboxMarkAllReadBody,
  ): Promise<typeInboxMarkAllReadOutput200 | typeInboxMarkAllReadOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postInboxMarkAllRead" failed before calling the network. #52fdcaa530b1`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#52fdcaa530b1" },
        },
        data: null,
      } as typeInboxMarkAllReadOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/inbox/mark-all-read`,
      httpMethod: "POST",
      options,
    })) as typeInboxMarkAllReadOutput200 | typeInboxMarkAllReadOutput400;
  };
}
